export default __webpack_public_path__ + "static/media/No1Closed.fc2c08b2.jpg";